// extracted by mini-css-extract-plugin
module.exports = {"comments":"PhotoComments_comments__Fq9Fw","single":"PhotoComments_single__mbtUS"};